<template>
    <div class="ibox ">
        <div class="ibox-title">
            <h5>{{ title }}</h5>
            <div class="ibox-tools">
                <slot name="tools">
                </slot>
            </div>
        </div>
        <div
            class="ibox-content"
            :class=" { 'sk-loading': loading } "
        >
            <div class="sk-spinner sk-spinner-wave">
                <div class="sk-rect1"></div>
                <div class="sk-rect2"></div>
                <div class="sk-rect3"></div>
                <div class="sk-rect4"></div>
                <div class="sk-rect5"></div>
            </div>

            <slot
                name="content"
                :setLoading="setLoading"
                @eventEmite="eventHandler"
            >
            </slot>

        </div>
    </div>
</template>

<script>
export default {
    name: 'Ibox',
    data() {
        return {
            loading: true
        }
    },
    props: {
        title: {
            type: String,
            default: 'Lista'
        },
        eventHandler: {
            type: Function
        }
    },
    methods: {
        setLoading( e ) {
            this.loading = e
        }
    }
}
</script>

